import EditStudentPage from "@/pages/students/edit-student";
import PrivateLayout from "@/components/layouts/private-layout";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/students/$studentId/edit",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PrivateLayout>
      <EditStudentPage />
    </PrivateLayout>
  );
}
